// extracted by mini-css-extract-plugin
export var dropdownButton = "_2t-0";
export var fullWidthDropdownButton = "_2t-1";
export var icon = "_2t-3";
export var iconPlaceholder = "_2t-2";
export var menuItemRow = "_2t-9";
export var separator = "_2t-e";
export var shortcutContainer = "_2t-7";
export var shortcutContainerFilled = "_2t-8";
export var shortcutIconLg = "_2t-6";
export var shortcutIconMd = "_2t-5";
export var shortcutIconSm = "_2t-4";
export var submenuChevron = "_2t-d";
export var submenuDropdown = "_2t-a";
export var submenuTriggerRow = "_2t-b";
export var submenuTriggerRowOpen = "_2t-c";